import { db, timestamp, functions, auth } from "../firebase";

const presets = {
  telegram: true,
  freeEvent: { isActive: true }
};

export default {
  state: {
    user: {}
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    clearUser(state) {
      state.user = {};
    }
  },
  actions: {
    async createUser({ dispatch, commit }, { email, name }) {
      try {
        const uid = await dispatch("getUid");
        await db
          .collection("users")
          .doc(uid)
          .set({
            email,
            name,
            userId: uid,
            createdAt: timestamp,
            ...presets
          });
      } catch (err) {
        commit("setError", err);
        throw err;
      }
    },
    async fetchUser({ dispatch, commit }) {
      try {
        const uid = await dispatch("getUid");
        const user = await db
          .collection("users")
          .doc(uid)
          .get();
        commit("setUser", user.data());
      } catch (err) {
        commit("setError", err);
        throw err;
      }
    },
    async fetchUserByEmail({ commit, getters }, userEmail) {
      // Permission check
      if (!getters.employee) {
        commit("setError", "unauthorized");
        return;
      }

      try {
        let snapshot = await db
          .collection("users")
          .where("email", "==", userEmail)
          .get();

        const docs = [];
        snapshot.docs.forEach(doc => {
          docs.push(doc.data());
        });

        if (docs.length === 1) return docs[0].userId;
        return;
      } catch (err) {
        commit("setError", err);
        throw err;
      }
    },
    async updateUser({ commit, dispatch }, payload) {
      try {
        const uid = await dispatch("getUid");
        await db
          .collection("users")
          .doc(uid)
          .update({ updatedAt: timestamp, ...payload });
        await dispatch("fetchUser");
      } catch (err) {
        commit("setError", err);
        throw err;
      }
    },
    async subscribeToEmailNotifications({ commit, getters }) {
      try {
        const { name, email } = getters.user;
        const addToAddressBook = functions.httpsCallable("addToAddressBook");
        await addToAddressBook({ name, email });
      } catch (err) {
        commit("setError", err);
        throw err;
      }
    },
    async logEvent({ commit, getters }, payload) {
      try {
        const { user } = getters;
        const logUserEvent = functions.httpsCallable("logUserEvent");
        await logUserEvent({ ...payload, user });
      } catch (err) {
        commit("setError", err);
        throw err;
      }
    }
  },
  getters: {
    user: s => s.user,
    subscription: s => {
      //? s.user.courses = [{ courseId: subEndDate }]
      if (!s.user.courses) return false;
      const dates = Object.values(s.user.courses);
      return dates.some(d => new Date() < new Date(d.toDate()));
    },
    activeCourses: s => {
      if (!s.user.courses) return [];
      const courses = s.user.courses;
      return Object.keys(courses).reduce((ids, key) => {
        if (new Date() <= new Date(courses[key].toDate())) ids.push(key);
        return ids;
      }, []);
    },
    employee: s => {
      // TODO move logic to auth custom token 'role'
      const isCorpEmail = s.user && /.*@facestudio\.online$/.test(s.user.email);
      const isEmailVerified =
        auth.currentUser && auth.currentUser.emailVerified;
      return isCorpEmail && isEmailVerified;
    }
  }
};
